import Reveal from "@/components/base/Reveal";
import Eyebrow from "@/components/base/Eyebrow";
import ContactForm from "@/pages/home/components/ContactForm";
import { brand } from "@/mocks/site";
import { INSTAGRAM_URL, FACEBOOK_URL, TIKTOK_URL, buildWhatsAppLink } from "@/utils/links";

const contactDetails = [
  { icon: "ri-map-pin-line", label: "Dirección", value: brand.address },
  { icon: "ri-phone-line", label: "Teléfono", value: brand.phoneDisplay },
  { icon: "ri-mail-line", label: "Correo", value: brand.email },
];

const socialLinks = [
  { icon: "ri-instagram-line", label: "Instagram", href: INSTAGRAM_URL },
  { icon: "ri-facebook-circle-line", label: "Facebook", href: FACEBOOK_URL },
  { icon: "ri-tiktok-line", label: "TikTok", href: TIKTOK_URL },
  { icon: "ri-whatsapp-line", label: "WhatsApp", href: buildWhatsAppLink("Hola ALÉA, quiero información.") },
];

export default function ContactBand() {
  return (
    <section id="contacto" className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute -right-24 top-16 h-[380px] w-[380px] rounded-full glow-lilac blur-3xl" />
      <div className="pointer-events-none absolute -left-24 bottom-16 h-[340px] w-[340px] rounded-full glow-beige blur-3xl" />
      <div className="relative mx-auto w-full max-w-[1400px] px-5 py-20 md:px-10 md:py-28">
        <Reveal className="max-w-2xl">
          <Eyebrow>Contacto</Eyebrow>
          <h2 className="mt-3 font-heading text-4xl font-bold leading-[1.05] text-foreground-950 md:text-5xl">
            Visítanos en {brand.city}
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-foreground-600">
            Agenda tu valoración, pregunta por nuestros productos o solicita información de cursos e
            insumos. Respondemos por WhatsApp durante nuestro horario.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-6">
            <Reveal>
              <ul className="space-y-5">
                {contactDetails.map((detail) => (
                  <li key={detail.label} className="flex items-start gap-4">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-[14px] border border-accent-200 bg-accent-50 text-accent-700">
                      <i className={`${detail.icon} text-lg`} />
                    </span>
                    <div>
                      <p className="font-label text-[10px] font-medium uppercase tracking-[0.18em] text-foreground-400">
                        {detail.label}
                      </p>
                      <p className="mt-1 text-sm leading-relaxed text-foreground-900">{detail.value}</p>
                    </div>
                  </li>
                ))}
                <li className="flex items-start gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-[14px] border border-accent-200 bg-accent-50 text-accent-700">
                    <i className="ri-time-line text-lg" />
                  </span>
                  <div>
                    <p className="font-label text-[10px] font-medium uppercase tracking-[0.18em] text-foreground-400">
                      Horarios
                    </p>
                    <div className="mt-1 space-y-1">
                      {brand.hours.map((item) => (
                        <p key={item.day} className="text-sm text-foreground-900">
                          <span className="text-foreground-500">{item.day}:</span> {item.time}
                        </p>
                      ))}
                    </div>
                  </div>
                </li>
              </ul>

              <div className="mt-8 flex items-center gap-3">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="nofollow noreferrer"
                    aria-label={social.label}
                    className="flex h-11 w-11 items-center justify-center rounded-full border border-secondary-300 text-foreground-700 transition-colors duration-300 hover:border-primary-500 hover:bg-primary-500 hover:text-background-50"
                  >
                    <i className={`${social.icon} text-lg`} />
                  </a>
                ))}
              </div>
            </Reveal>

            <Reveal delay={120} className="mt-8">
              <div className="card-soft h-[300px] w-full overflow-hidden rounded-[24px] border border-secondary-200 md:h-[340px]">
                <iframe
                  title="Ubicación de ALÉA Aesthetic House en Culiacán"
                  src="https://maps.google.com/maps?q=Culiac%C3%A1n%2C%20Sinaloa%2C%20M%C3%A9xico&t=&z=12&ie=UTF8&iwloc=&output=embed"
                  className="h-full w-full"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </Reveal>
          </div>

          <Reveal delay={140} className="lg:col-span-6">
            <ContactForm />
          </Reveal>
        </div>
      </div>
    </section>
  );
}